export const ISRAEL_TAX_REGULATION_BLOCKED_BY_USER = 'israelTaxRegulation_isBlockedByUser';
export const ISRAEL_TAX_REGULATION_SHOWN_TODAY = 'israelTaxRegulation_ShownToday';
